import { ReactNode, useEffect, useRef, useState } from "react";
// @mui
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  CardProps,
  TableContainer,
  useTheme,
  // alpha,
} from "@mui/material";
// components

import Scrollbar from "../../components/scrollbar/Scrollbar";
import { TableHeadCustom } from "../../components/table";

export interface CodeRowProps {
  /** code */
  code: string;
  /** 提示 */
  tip: string;
  /** 描述 */
  desc: ReactNode;
  [key: string]: any;
}

export interface CodeTableLabelItemProps {
  id: string;
  label: string;
  isFixed?: boolean;
}

interface Props extends CardProps {
  tableData: CodeRowProps[];
  tableLabels: CodeTableLabelItemProps[];
}
export default function CodeTable({ tableData, tableLabels, ...other }: Props) {
  const theme = useTheme();

  const [isFixed, setIsFixed] = useState(false);

  const srcollRef = useRef<any>(null);

  useEffect(() => {
    // var scrollable = document.getElementById("scrollable");
    const scrollable = srcollRef.current;

    function scroll(e: any) {
      if (
        e.target.scrollLeft + e.target.clientWidth <
        e.target.scrollWidth - 10
      ) {
        console.log({
          scrollLeft: e.target.scrollLeft,
          b: e.target.clientWidth,
          c: e.target.scrollWidth,
        });
        setIsFixed(true);
      }

      if (e.target.scrollLeft >= 0 && e.target.scrollLeft <= 10) {
        setIsFixed(false);
        console.log({
          scrollLeft: e.target.scrollLeft,
          b: e.target.clientWidth,
          c: e.target.scrollWidth,
        });
      }

      // if (e.target.scrollLeft + e.target.clientWidth === e.target.scrollWidth) {
      //   setIsFixed(false);
      // }
    }

    if (scrollable?.contentWrapperEl) {
      scrollable.contentWrapperEl.addEventListener("scroll", scroll);
    }
    return () => {
      if (scrollable?.contentWrapperEl) {
        scrollable?.contentWrapperEl.removeEventListener("scroll", scroll);
      }
    };
  }, []);

  return (
    <Box
      {...other}
      sx={{
        // borderRadius: "0px 0px 16px 16px",
        borderLeft: isFixed ? `1px solid ${theme.palette.text.stroke}` : "none",
      }}
    >
      <TableContainer sx={{ overflow: "unset" }}>
        <Scrollbar ref={srcollRef} className="action">
          <Table
            sx={{
              minWidth: 720,
              "& .MuiTableRow-root": {
                border: `1px solid ${theme.palette.text.stroke}`,
              },
            }}
          >
            <TableHeadCustom
              headLabel={tableLabels.map((tableLabel, i) => {
                const item = { ...tableLabel };
                if (i === 0) {
                  item.isFixed = isFixed;
                }
                return item;
              })}
              sx={{
                "& .MuiTableCell-root": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? theme.palette.grey[100]
                      : theme.palette.grey[900],
                  color: theme.palette.text.secondary,
                  fontWeight: 400,
                  fontSize: "14px",
                  letterSpacing: "0.1px",
                  lineHeight: "24px",
                  borderRight: `1px solid ${theme.palette.text.stroke}`,
                },
              }}
            />

            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? theme.palette.grey[0]
                      : theme.palette.grey[900],
                  color: theme.palette.text.primary,
                  fontWeight: 400,
                  fontSize: "14px",
                  letterSpacing: "0.1px",
                  borderRight: `1px solid ${theme.palette.text.stroke}`,
                },
              }}
            >
              {tableData.map((row) => (
                <CodeTableRow key={row.code} row={row} isFixed={isFixed} />
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>
    </Box>
  );
}

type TableRowProps = {
  row: CodeRowProps;
  isFixed: boolean;
};

function CodeTableRow({ row, isFixed }: TableRowProps) {
  return (
    <>
      <TableRow
        sx={{
          "&:hover": {
            td: {
              backgroundColor: "#F3F3F4",
            },
          },
        }}
      >
        {row?.code && (
          <TableCell
            className={`${isFixed ? "cell-fixed" : ""}`}
            key={row.code}
          >
            {row.code}
          </TableCell>
        )}

        {row?.tip && <TableCell>{row.tip}</TableCell>}

        {row?.desc && <TableCell>{row.desc}</TableCell>}
      </TableRow>
    </>
  );
}
